import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyHotelUpgradeBenefitsModal from './LandingPageLoyaltyHotelUpgradeBenefitsModal'

const image: App.Image = {
  id: 'wfzka1j5ru5d5e7hc9u',
  title: 'Free room upgrades',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyHotelUpgrade(props: Props) {
  const { tier, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyHotelUpgradeBenefitsModal
      image={image}
      tier={tier}
      numberOfBenefitRemaining={benefit.remaining ?? 0}
    />)
  }, [showModal, tier, benefit])

  return <LandingPageLoyaltyBenefitTile
    heading="Free room upgrades"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Elevate your stay. Enjoy complimentary room upgrades at participating hotels—subject to availability—so you can travel in even more style.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyHotelUpgrade
